import BasicTemplate from '../templates/BasicTemplate'
import btechCloud from '../../Assets/layout_images/btechCloud.png'
import btechWave1 from '../../Assets/layout_images/btechWave1.png'
import { faqs } from '../utils/faqs'
import FaqContainer from '../partialComponents/FaqContainer'
import { whoCanBenefit } from '../utils/whoCanBenefit'
import HelmetGenerator from '../partialComponents/HelmetGenerator'
import { helmets } from '../utils/helmets'
import { useEffect,useState } from 'react'
import BtechHero from '../partialComponents/BtechHero'
import BtechBenefits from '../partialComponents/BtechBenefits'
import GetStarted from '../partialComponents/GetStarted'
import WhoCanBenefitHeptagon from '../partialComponents/WhoCanBenefitHeptagon'
import { pdfjs, Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
// import { Document } from 'react-pdf'
import { useLocation } from 'react-router'
// import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
// import btechpdf from '../../Assets/pdfs/btech.pdf'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
export default function Btech() {
    const [numPages, setNumPages] = useState(null);

    function handleLoadSuccess({ numPages }) {
      setNumPages(numPages);
    }
    const location = useLocation()

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [location])
    return (
        <>
            <HelmetGenerator details={helmets.btech} />

            <BasicTemplate>
                <div className="btech_section">
                <Document
                    file="/btech.pdf" // Make sure sample.pdf is in the public folder
                    onLoadSuccess={handleLoadSuccess}
                    onLoadError={console.error}
                >
                    {Array.from({ length: numPages }, (_, index) => (
                    <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                    ))}
                </Document>
                </div>
            </BasicTemplate>
        </>
    )
}
